// extracted by mini-css-extract-plugin
export default {"control":"schedule_control__dsjry","Cancel":"schedule_Cancel__qTVjR"};